import React, { useState, useRef, useEffect } from 'react';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import Divider from '@mui/material/Divider';
import ListItemSecondaryAction from '@mui/material/ListItemSecondaryAction';
import { faEdit } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import store from 'store-js';
import styles from '../../styles/RecordList.module.scss';
import API from '../../services/api';
import ImageGallery from '../../components/imageGallery';
import imageCompression from 'browser-image-compression';
import { useCookieState } from 'ahooks';

const noRecordStyle = {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    marginTop: '50px',
    color: '#888888'
};

export default function RecordList({ data, handleErr, handleUpdated, t, config }) {
    const [token, setToken] = useCookieState('access_token', { secure: true, sameSite: 'strict' });
    const MAX_UPLOAD_FILE = 3;

    const [customerId, setCustomerId] = useState(null);

    useEffect(() => {
        if (data?.length > 0 && data[0].customer_id) {
            setCustomerId(data[0].customer_id);
        }
    }, [data]);

    const Record = ({ item }) => {
        const [spending, setSpending] = useState(
            item.spending !== '-' && item.spending.length > 0 ? item.spending : '-'
        );
        const [remarks, setRemarks] = useState(item.remarks);
        const [receiptNum, setReceiptNum] = useState(item.receipt?.length > 0 ? item.receipt : '-');
        const [receiptNumChanged, setReceiptNumChanged] = useState(false);
        const [isEditing, setIsEditing] = useState(false);
        const [confirmEdit, setConfirmEdit] = useState(false);
        const [confrimDisabled, setConfirmDisabled] = useState(false);
        const [itemID, setItemID] = useState(null);
        const [invalidSpending, setInvalidSpending] = useState(false);
        const [showReceiptLimitWarning, setReceiptLimitWarning] = useState(false);
        const [showRemarksLimitWarning, setRemarksLimitWarning] = useState(false);
        const [isPostingData, setIsPostingData] = useState(false);

        //attachments
        const [attachmentArr, setAttachmentArr] = useState([]);
        const [receiptBase64s, setReceiptBase64s] = useState([]);
        const [receiptFiles, setReceiptFiles] = useState([]);

        const spendingRef = useRef(null);
        const remarksRef = useRef(null);
        const receiptRef = useRef(null);
        const imageUploadRef = useRef(null);
        const receiptPreviewUrlsRef = useRef([]);

        // console.log({ item });
        const attachmentUploadByShop = attachmentArr?.filter((e) => e.is_admin_user === '0' || !e.is_admin_user);

        const UPLOAD_FILE_QUOTA = MAX_UPLOAD_FILE - attachmentUploadByShop?.length;

        receiptPreviewUrlsRef.current = receiptBase64s;

        useEffect(() => {
            if (item.attachments) {
                const attachments = Object.values(item.attachments);
                if (attachments?.length > 0) {
                    let tempAttachmentArr = [];
                    attachments.map((attachment) => {
                        tempAttachmentArr.push(attachment);
                    });
                    setAttachmentArr(tempAttachmentArr);
                }
            }
            setCustomerId(item?.customer_id);
        }, [item]);

        useEffect(() => {
            return () => {
                receiptPreviewUrlsRef.current.forEach((url) => {
                    if (url?.startsWith('blob:')) {
                        URL.revokeObjectURL(url);
                    }
                });
            };
        }, []);

        useEffect(() => {
            /* Dummy Code Testing */
            // if (confirmEdit) {
            //   if (
            //     spending !== item.spending ||
            //     remarks !== item.remarks ||
            //     receiptNum !== item.receipt
            //   ) {
            //     let newObj = Object.assign(item, {
            //       spending: spending,
            //       remarks: remarks,
            //       receipt: receiptNum,
            //     });

            //     let history = store.get("records");
            //     history.map((item, i) => {
            //       if (item.id != newObj.id) return;
            //       history.splice(i, 1, newObj);
            //       // console.log(history);
            //     });
            //     store.set("records", history);
            //   } else return;

            //   setIsEditing(false);
            //   setInvalidSpending(false);
            //   setReceiptLimitWarning(false);
            //   setRemarksLimitWarning(false);
            //   setConfirmEdit(false);
            // }
            ///////////////////////////////////////////////////////
            if (confirmEdit && !isPostingData) {
                const api = new API(token);
                if (receiptNumChanged) updateReceipt(item.id, receiptNum);
                // if (item.remarks === remarks && item.spending === spending) return;
                if (receiptFiles?.length > 0) {
                    setIsPostingData(true);
                    uploadFiles(receiptFiles)
                        .then(async (res) => {
                            const media_res_arr = res
                                .filter((r) => r?.response?.code === '200')
                                .map((r) => ({
                                    media_id: r.payload.id,
                                    token: r.payload.token,
                                    file_path: r.payload.file_path
                                }));
                            try {
                                const updateVoucherAttachmentPromise =
                                    media_res_arr?.length > 0 &&
                                    media_res_arr?.map((media) => {
                                        return api.updateVoucherAttachment(item.id, media.token);
                                    });
                                const updateVoucherAttachmentRes = await Promise.all(updateVoucherAttachmentPromise);
                                if (updateVoucherAttachmentRes[0].response.code === '200') {
                                    setTimeout(() => {
                                        api.updateRedeemInfo(item.id, spending, remarks)
                                            .then((res) => {
                                                if (res && res.response.code === '200') {
                                                    console.log('Edit successful');
                                                    return window.location.reload();
                                                } else if (res.response.code === '400') {
                                                    if (res.response.message === 'invalid access token') {
                                                        handleErr(3);
                                                        return;
                                                    }
                                                    handleErr(2);
                                                    console.log(res);
                                                } else {
                                                    handleErr(`${t('errMsg_networkErr')} (${res.response.code})`);
                                                }
                                            })
                                            .catch((err) => {
                                                handleErr(1);
                                                console.log(err);
                                            })
                                            .finally(() => {
                                                setIsPostingData(false);
                                                setReceiptLimitWarning(false);
                                                setReceiptNumChanged(false);
                                                setIsEditing(false);
                                                setConfirmEdit(false);
                                            });
                                    }, 400);
                                }
                            } catch (error) {
                                console.error('Failed to update voucher attachments:', error);
                            }
                        })
                        .catch((err) => {
                            handleErr(1);
                            console.log(err);
                        });
                } else {
                    setTimeout(() => {
                        api.updateRedeemInfo(item.id, spending, remarks)
                            .then((res) => {
                                if (res && res.response.code === '200') {
                                    console.log('Edit successful');
                                    return window.location.reload();
                                } else if (res.response.code === '400') {
                                    if (res.response.message === 'invalid access token') {
                                        handleErr(3);
                                        return;
                                    }
                                    handleErr(2);
                                    console.log(res);
                                } else {
                                    handleErr(`${t('errMsg_networkErr')} (${res.response.code})`);
                                }
                            })
                            .catch((err) => {
                                handleErr(1);
                                console.log(err);
                            })
                            .finally(() => {
                                setReceiptLimitWarning(false);
                                setReceiptNumChanged(false);
                                setIsEditing(false);
                                setConfirmEdit(false);
                            });
                    }, 400);
                }
            } else return;
        }, [confirmEdit, spending, remarks, receiptNumChanged, receiptNum]);

        /* Add || Update Receipt Number */
        const updateReceipt = (id, receiptNum) => {
            const api = new API(token);

            // Determine add or update receipt
            let type = item.receipt?.length > 0 ? 'update' : 'add';
            let apiCall =
                type === 'update'
                    ? api.updateVoucherMetaData(id, item.receiptId, receiptNum)
                    : api.addMetadataToVoucher(id, 'receipt_no', receiptNum);

            apiCall
                .then((res) => {
                    if (res && !res.hasOwnProperty('error')) {
                        type === 'add' ? console.log('Receipt Number added.') : console.log('Receipt Number Updated.');
                        setReceiptNumChanged(false);
                        handleUpdated(id, receiptNum);
                    } else {
                        console.log(res);
                        if (res.error !== 'invalidToken') {
                            handleErr('serverErr');
                        } else handleErr(t(`${config.scannerErr_setting.errMsg.invalidToken}`));
                    }
                })
                .catch((err) => {
                    console.log(err);
                    handleErr('networkErr');
                })
                .finally(() => {
                    setIsEditing(false);
                    setConfirmEdit(false);
                });
        };

        const calcTotalQty = (data) => {
            let total = 0;
            for (let i of data) {
                total += Number(i.qty);
            }
            return total;
        };

        const handleSpendingChange = (e) => {
            if (e.target.value.length === 0) return setInvalidSpending(false);

            let pattern = /^[0-9\b]+$/;
            let val = e.target.value.toString().split('.')[0];

            if (!pattern.test(e.target.value)) {
                setInvalidSpending(true);
                setConfirmDisabled(true);
            }

            if (val.length > 0 && val.length <= 10) {
                let newSpending = e.target.value
                    .toString()
                    .split('.')
                    .map((el, i) => (i ? el.split('').slice(0, 1).join('') : el))
                    .join('.');

                if (
                    Number(newSpending) < Number(item.total) ||
                    parseInt(e.target.value) < item.coupons[0].min_spending_amount * calcTotalQty(item.coupons)
                ) {
                    setInvalidSpending(true);
                    setConfirmDisabled(true);
                } else {
                    // setSpending(newSpending);
                    setInvalidSpending(false);
                    setConfirmDisabled(false);
                }
            }
        };

        const handleRemarksChange = (e) => {
            let remarksVal = e.target.value;
            if (remarksVal.length <= 30) {
                // setRemarks(e.target.value);
                setRemarksLimitWarning(false);
                setConfirmDisabled(false);
            } else {
                setRemarksLimitWarning(true);
                setConfirmDisabled(true);
            }
        };

        const handleReceiptChange = (e) => {
            let receiptVal = e.target.value;

            if (receiptVal !== receiptNum) setReceiptNumChanged(true);

            if (receiptVal === '') setReceiptNum('-');

            if (receiptVal.length > 45) {
                setReceiptLimitWarning(true);
                setConfirmDisabled(true);
            } else {
                setReceiptLimitWarning(false);
                setConfirmDisabled(false);
            }
        };

        const revokePreviewUrls = (urls = []) => {
            urls.forEach((url) => {
                if (url?.startsWith('blob:')) {
                    URL.revokeObjectURL(url);
                }
            });
        };

        const onChange = (event) => {
            const files = event.target.files;
            if (files && files.length > 0) {
                const remaining = UPLOAD_FILE_QUOTA - receiptFiles.length;
                const filesToAdd = Array.from(files).slice(0, Math.max(0, remaining));
                const previewUrls = filesToAdd.map((file) => URL.createObjectURL(file));

                setReceiptFiles((prevList) => [...prevList, ...filesToAdd]);
                setReceiptBase64s((prevList) => [...prevList, ...previewUrls]);
            }
            // Allow selecting the same file again without remounting the input
            event.target.value = '';
        };

        const handleUpdate = () => {
            if (confrimDisabled) return;

            spendingRef.current.value.length === 0 ? setSpending('-') : setSpending(spendingRef.current.value);
            receiptRef.current.value.length === 0 ? setReceiptNum('-') : setReceiptNum(receiptRef.current.value);
            remarksRef.current.value.length === 0 ? setRemarks('-') : setRemarks(remarksRef.current.value);
            setConfirmEdit(true);
            setItemID(item.id);

            // if (
            //     receiptNum !== receiptRef.current.value ||
            //     spending !== spendingRef.current.value ||
            //     remarks !== remarksRef.current.value
            // ) {
            //     spendingRef.current.value.length === 0 ? setSpending('-') : setSpending(spendingRef.current.value);

            //     setReceiptNum(receiptRef.current.value);
            //     remarksRef.current.value.length === 0 ? setRemarks('-') : setRemarks(remarksRef.current.value);
            //     setConfirmEdit(true);
            //     setItemID(item.id);
            // } else {
            //     setIsEditing(false);
            //     return;
            // }
        };

        const cancelUpdate = () => {
            setIsEditing(false);
            setSpending(item.spending);
            setRemarks(item.remarks);
            setReceiptNum(item.receipt);
            setReceiptNumChanged(false);
            setConfirmEdit(false);
            setReceiptLimitWarning(false);
            setRemarksLimitWarning(false);
            setInvalidSpending(false);
            revokePreviewUrls(receiptBase64s);
            setReceiptFiles([]);
            setReceiptBase64s([]);
        };

        const uploadFiles = async (file_arr) => {
            try {
                const api = new API(token);
                var options = {
                    maxSizeMB: 1,
                    maxWidthOrHeight: 1920,
                    useWebWorker: true
                };
                const uploadPromises = file_arr.map(async (file) => {
                    // Reconstruct File — avoids Android Chrome blob/file quirks from the photo picker
                    const buffer = await file.arrayBuffer();
                    const stableFile = new File([buffer], file.name || 'receipt.jpg', {
                        type: file.type || 'image/jpeg',
                        lastModified: file.lastModified
                    });
                    const compressedFile = await imageCompression(stableFile, options);
                    console.log('compressedFile instanceof Blob', compressedFile instanceof Blob); // true
                    console.log(`compressedFile size ${compressedFile.size / 1024 / 1024} MB`); // smaller than maxSizeMB
                    return api.uploadMedia(customerId, compressedFile); // Use compressedFile instead of file
                });
                const results = await Promise.all(uploadPromises);
                return results;
                // return await Promise.all(uploadPromises);
            } catch (error) {
                console.error('Error uploading files:', error);
            }
        };

        const handleUploadReceipt = (event) => {
            imageUploadRef.current.click();
        };

        return item && item.redeemID ? (
            <div className={styles.recordDiv}>
                <List>
                    <div className={styles.titleDiv}>
                        <h4
                            style={{
                                margin: '15px 20px',
                                maxWidth: '190px',
                                lineBreak: 'anywhere',
                                textAlign: 'left',
                                color: config.theme.color
                            }}
                        >
                            {t('recordsPage_recordNum')}
                            <br />
                            <span>#{item.redeemID}</span>
                        </h4>
                        <p className={styles.date}>{item.date}</p>
                    </div>

                    {item.coupons?.map((coupon, index) => (
                        <React.Fragment key={index}>
                            <ListItem style={{ padding: '12px 40px 12px 0' }} className={styles.boldTxtList}>
                                {coupon.name}
                                <ListItemSecondaryAction>x{coupon.qty}</ListItemSecondaryAction>
                            </ListItem>
                            <Divider light />
                        </React.Fragment>
                    ))}
                </List>
                {/* <List style={{ paddingTop: "12px" }} className={styles.boldTxtList}>
          <ListItem className={styles.listItem}>
            {t("redeem_coupons_subtotal_label")}
            <ListItemSecondaryAction>${item.total}</ListItemSecondaryAction>
          </ListItem>
        </List> */}

                {/* TOTAL SPENDING */}
                <List className={styles.boldTxtList}>
                    <ListItem className={styles.listItem} style={{ display: 'inline-block' }}>
                        {t('recordsPage_originalSpending')}
                        {isEditing ? (
                            <>
                                <input
                                    type="number"
                                    inputMode="decimal"
                                    pattern="^\d+\.{0,1}\d{0,2}$"
                                    className={styles.receiptInput}
                                    defaultValue={item.spending}
                                    ref={spendingRef}
                                    onChange={(e) => handleSpendingChange(e)}
                                    style={{
                                        borderColor: invalidSpending ? 'red' : '#888'
                                    }}
                                    onKeyDown={(e) => ['e', 'E'].includes(e.key) && e.preventDefault()}
                                />
                                <p
                                    style={{
                                        color: '#D46666',
                                        textAlign: 'right',
                                        // position: 'absolute',
                                        right: '0',
                                        display: invalidSpending ? 'block' : 'none'
                                    }}
                                >
                                    {t('redeem_expenseTotal_min_spending_error')}
                                </p>
                            </>
                        ) : (
                            <ListItemSecondaryAction>
                                {spending !== '-'
                                    ? //  && spending.toString().length > 1
                                      `$${spending.toString().replace(/\B(?=(?:\d{3})+)$/g, ',')}`
                                    : // : spending === "0"
                                      // ? `$0`
                                      spending}
                            </ListItemSecondaryAction>
                        )}
                    </ListItem>
                </List>

                {/* REMARKS */}
                <List className={styles.boldTxtList}>
                    <ListItem className={styles.listItem} style={{ display: 'inline-block' }}>
                        {t('recordsPage_remarks')}
                        {isEditing ? (
                            <>
                                <input
                                    className={styles.receiptInput}
                                    defaultValue={item.remarks}
                                    ref={remarksRef}
                                    onChange={(e) => handleRemarksChange(e)}
                                />
                                <p
                                    style={{
                                        color: '#D46666',
                                        textAlign: 'right',
                                        position: 'absolute',
                                        right: '0',
                                        display: showRemarksLimitWarning ? 'block' : 'none'
                                    }}
                                >
                                    {t('redeem_remarks_input_error')}
                                </p>
                            </>
                        ) : (
                            <ListItemSecondaryAction>{remarks ? remarks : '-'}</ListItemSecondaryAction>
                        )}
                    </ListItem>
                </List>

                {/* RECEIPT NUM */}
                <List className={styles.boldTxtList} style={{ paddingBottom: '15px' }}>
                    <ListItem className={styles.listItem} style={{ display: 'inline-block' }}>
                        {t('recordsPage_receiptNum_label')}
                        {isEditing ? (
                            <>
                                <input
                                    className={styles.receiptInput}
                                    defaultValue={receiptNum}
                                    ref={receiptRef}
                                    onChange={(e) => handleReceiptChange(e)}
                                />
                                <p
                                    style={{
                                        color: '#D46666',
                                        textAlign: 'right',
                                        position: 'absolute',
                                        right: '0',
                                        display: showReceiptLimitWarning ? 'block' : 'none'
                                    }}
                                >
                                    {t('redeem_receipt_input_error')}
                                </p>
                            </>
                        ) : (
                            <ListItemSecondaryAction
                                style={{
                                    maxWidth: '230px',
                                    wordBreak: 'break-all'
                                    // paddingTop: "15px",
                                }}
                            >
                                {receiptNum}
                            </ListItemSecondaryAction>
                        )}
                    </ListItem>
                </List>
                {isEditing &&
                    receiptFiles?.length < UPLOAD_FILE_QUOTA &&
                    parseInt(item.coupons[0].min_spending_amount) > 0 && (
                        <button
                            type="button"
                            className={`colorBtn ${styles.save}`}
                            style={{ marginLeft: 10 }}
                            onClick={handleUploadReceipt}
                        >
                            {t('recordsPage_upload_receipt_btn_label')}
                        </button>
                    )}

                {(attachmentArr?.length > 0 || receiptBase64s?.length > 0) && (
                    // <div style={{ display: 'flex', flexDirection: 'row', marginTop: 12, overflowX: 'scroll' }}>
                    <ImageGallery
                        config={config}
                        receiptFiles={receiptFiles}
                        setReceiptFiles={setReceiptFiles}
                        receiptBase64s={receiptBase64s}
                        setReceiptBase64s={setReceiptBase64s}
                        attachmentArr={attachmentArr}
                    />
                    // </div>
                )}

                {isEditing ? (
                    <div className={styles.editBtnsDiv}>
                        <button type="button" className={styles.greyBtn} onClick={cancelUpdate}>
                            {t('recordsPage_cancelEditRemarks_label')}
                        </button>

                        <button
                            type="button"
                            className={confrimDisabled ? styles.greyBtn : `colorBtn ${styles.save}`}
                            onClick={handleUpdate}
                        >
                            {t('recordsPage_confirmEditRemarks_label')}
                        </button>
                    </div>
                ) : (
                    <>
                        <div style={{ display: 'flex', justifyContent: 'end' }}>
                            <button type="button" className="colorBtn right" onClick={(e) => setIsEditing(true)}>
                                <FontAwesomeIcon
                                    icon={faEdit}
                                    style={{
                                        paddingRight: '5px',
                                        width: '25px',
                                        marginBottom: '-2px'
                                    }}
                                />
                                {t('recordsPage_edit_label')}
                            </button>
                        </div>
                    </>
                )}
                <input
                    ref={imageUploadRef}
                    style={{ display: 'none' }}
                    id="receipt-file-upload"
                    type="file"
                    multiple
                    accept="image/*"
                    onChange={onChange}
                />
            </div>
        ) : (
            <></>
        );
    };

    return data && data.length > 0 ? (
        data.map((item, index) => <Record {...{ item }} key={index} handleErr={handleErr} />)
    ) : (
        <p style={noRecordStyle}>{t('recordsPage_noRecord')}</p>
    );
}
